import axios from "axios";
import { Message, MessageBox } from "element-ui";
import { getUrlArgObject } from "./spilturl.js";
import router from "../router";

let BASE_URL = "https://www.58zltc.com"; //正式地址
if (localStorage.getItem("baseStatus") == "test") {
  BASE_URL = "https://cs.58zltc.com"; //测试
}
var user_token = getUrlArgObject().token;
// create an axios instance
const service = axios.create({
  transformResponse: [
    function(data) {
      return data;
    },
  ],
  timeout: 20000, // request timeout
  headers: {
    token: user_token ? user_token : localStorage.getItem("token"),
  },
});
service.interceptors.request.use(
  (config) => {
    config.baseURL = BASE_URL;
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);
service.interceptors.response.use(
  (response) => {
    if (response.status !== 200) {
      Message({
        message: "Error",
        type: "error",
        duration: 5 * 1000,
      });
    } else {
      if (JSON.parse(response.data).code == 0) {
        MessageBox.confirm("登录信息过期，请重新登录", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            localStorage.removeItem("token");
            if (localStorage.getItem("baseStatus") == "test") {
              window.location.href =
                "https://cs.58zltc.com/#/login?redirect=%2Fmanage%2Fcenter";
              // router.push("/login");
            } else if (localStorage.getItem("baseStatus") == "online") {
              window.location.href =
                "https://www.58zltc.com/#/login?redirect=%2Fmanage%2Fcenter";
              // router.push("/login");
            }
          })
          .catch(() => {});
      } else if (JSON.parse(response.data).code == 4001) {
        localStorage.removeItem("token");
        if (localStorage.getItem("baseStatus") == "test") {
          window.location.href =
            "https://cs.58zltc.com/#/login?redirect=%2Fmanage%2Fcenter";
          // router.push("/login");
        } else if (localStorage.getItem("baseStatus") == "online") {
          window.location.href =
            "https://www.58zltc.com/#/login?redirect=%2Fmanage%2Fcenter";
          // router.push("/login");
        }
      }
      return JSON.parse(response.request.response);
    }
  },
  (error) => {
    Message({
      message: "连接超时，请刷新！",
      type: "error",
      duration: 5 * 1000,
    });
    return Promise.resolve(error);
  }
);
export { service, BASE_URL };
